import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { NotFoundComponent } from "./not-found/not-found.component";

const routes: Routes = [
	{
		path: "",

		children: [
			{
				path: "attempt",
				loadChildren: () =>
					import("src/app/attempt/attempt.module").then((m) => m.AttemptModule),
			},
			{
				path: "company",
				loadChildren: () =>
					import("src/app/company/company.module").then((m) => m.CompanyModule),
			},
			{
				path: "inductee",
				loadChildren: () =>
					import("src/app/inductee/inductee.module").then(
						(m) => m.InducteeModule
					),
			},
			{
				path: "portal",
				loadChildren: () =>
					import("src/app/portal/inductee/portal-inductee.module").then(
						(m) => m.PortalInducteeModule
					),
			},
			{
				path: "company-web-portal",
				loadChildren: () =>
					import("src/app/company-web-portal/company-web-portal.module").then(
						(m) => m.CompanyWebPortalModule
					),
			},
			{
				path: "contractor",
				loadChildren: () =>
					import("src/app/portal/contractor/portal-contractor.module").then(
						(m) => m.PortalContractorModule
					),
			},
			{
				path: "sign-in",
				loadChildren: () =>
					import("src/app/portal/sign-in/portal-sign-in.module").then(
						(m) => m.PortalSignInModule
					),
			},
			{
				path: "website",
				loadChildren: () =>
					import("src/app/website/website.module").then((m) => m.WebsiteModule),
			},
			{
				path: "invites",
				loadChildren: () =>
					import("src/app/invite/invite.module").then((m) => m.InviteModule),
			},
			{
				path: "auth",
				loadChildren: () =>
					import("src/app/auth/auth.module").then((m) => m.AuthModule),
			},
			{ path: "**", component: NotFoundComponent },
		],
	},
];

@NgModule({
	imports: [RouterModule.forRoot(routes, { useHash: true })],
	exports: [RouterModule],
})
export class AppRoutingModule {}
